import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e3b1836"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_page_wrap no_overlap" }
const _hoisted_2 = { class: "project_count_block_init" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project_count_title" }, "华美顾问集团", -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"blank_space\" data-v-0e3b1836></div><div class=\"_page_block_project_count project_count responsive_height\" data-v-0e3b1836><div class=\"project_count_block\" data-v-0e3b1836><div class=\"project_count_num\" data-v-0e3b1836>400+</div><div class=\"project_count_text\" data-v-0e3b1836>华美执行项目遍及 400+ 城市</div></div><div class=\"project_count_block\" data-v-0e3b1836><div class=\"project_count_num\" data-v-0e3b1836>1700+</div><div class=\"project_count_text\" data-v-0e3b1836>华美已为 1700+ 项目提供专业咨询服务</div></div></div><div class=\"blank_space\" data-v-0e3b1836></div>", 3)
const _hoisted_7 = { class: "_featured" }
const _hoisted_8 = { class: "_block_piece noTop" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleBox = _resolveComponent("ArticleBox")!
  const _component_Isotope = _resolveComponent("Isotope")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutTexts, (text, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "project_count_text custom_text",
          key: index,
          style: _normalizeStyle({ animationDelay: index + 's' })
        }, _toDisplayString(text), 5))
      }), 128))
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.articleBlock)
          ? (_openBlock(), _createBlock(_component_Isotope, {
              key: 0,
              class: "_block_piece_children",
              initialize: _ctx.isoInitialize,
              activated: _ctx.windowWidth>700,
              onNewWidth: _cache[0] || (_cache[0] = newWidth=>_ctx.handleNewWidth(newWidth, encodeURIComponent(_ctx.articleBlock.title)))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleBlock.children.slice(0, 10), (b1, b1Ind) => {
                  return (_openBlock(), _createBlock(_component_ArticleBox, {
                    _inactive: b1Ind<4,
                    class: "_article_box",
                    key: b1.title,
                    article: b1
                  }, null, 8, ["_inactive", "article"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["initialize", "activated"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}